document.addEventListener('bundler:bundle_widget_created', function () {
    const products = document.querySelectorAll('.bndlr-product');
    const fetchPromises = [];

    const isStaging = window.location.hostname.includes('staging');
    const apiDomain = isStaging
        ? 'https://staging-shop.gkelite.com'
        : 'https://www.gkelite.com';

    const apiToken = isStaging
        ? '7bdc456a5103c5f74524ec75f7e7bc5f' // staging token
        : 'bf38ba85942cdf6a202d29e6316b5484'; // production token

    console.log(`[Bundle Env] Using ${isStaging ? 'STAGING' : 'PRODUCTION'} endpoint: ${apiDomain}`);

    function waitForImages(selector, callback) {
        const images = document.querySelectorAll(selector);
        let loadedCount = 0;
        const total = images.length;
        if (total === 0) return callback();
        images.forEach(img => {
            if (img.complete || img.naturalHeight > 0) {
                loadedCount++;
                if (loadedCount === total) callback();
            } else {
                img.addEventListener('load', () => {
                    loadedCount++;
                    if (loadedCount === total) callback();
                });
                img.addEventListener('error', () => {
                    loadedCount++;
                    if (loadedCount === total) callback();
                });
            }
        });
    }

    function matchHeights() {
        let maxHeight = 0;
        products.forEach(p => p.style.height = 'auto');
        products.forEach(p => {
            const h = p.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        });
        products.forEach(p => p.style.height = `${maxHeight}px`);
        console.log('[Bundle Debug] Product blocks matched to:', maxHeight + 'px');
    }

    function matchTitleHeights() {
        const titles = document.querySelectorAll('.bndlr-product-title');
        let maxHeight = 0;
        titles.forEach(t => t.style.minHeight = 'auto');
        titles.forEach(t => {
            const h = t.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        });
        titles.forEach(t => t.style.minHeight = `${maxHeight}px`);
        console.log('[Bundle Debug] Title heights matched to:', maxHeight + 'px');
    }

    products.forEach(el => {
        el.classList.add('loading');
        const productLink = el.querySelector('a');
        if (!productLink) return;

        const rawHandle = productLink.getAttribute('href').split('/').pop();
        const productHandle = rawHandle.split('?')[0];

        const fetchPromise = fetch(`${apiDomain}/api/2023-10/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': apiToken
            },
            body: JSON.stringify({
                query: `
                    query {
                        productByHandle(handle: "${productHandle}") {
                            title
                            images(first: 1) {
                                edges {
                                    node {
                                        url
                                        altText
                                    }
                                }
                            }
                            metafield(namespace: "product", key: "ProductTitle") {
                                value
                            }
                        }
                    }
                `
            })
        })
        .then(res => res.json())
        .then(data => {
            const productData = data.data?.productByHandle;
            const metafieldValue = productData?.metafield?.value?.trim();
            const fallbackTitle = productData?.title?.trim() || 'Missing Title';
            const title = metafieldValue || fallbackTitle;

            const visibleTitle = el.querySelector('.bndlr-product-title');
            if (visibleTitle) {
                visibleTitle.textContent = title;

                if (!metafieldValue && !el.dataset.retried) {
                    console.warn(`[Bundle Debug] Missing metafield for ${productHandle}, retrying in 2s...`);
                    el.dataset.retried = 'true';
                    setTimeout(() => {
                        document.dispatchEvent(new CustomEvent('bundler:bundle_widget_created'));
                    }, 2000);
                }
            }

            const imageUrl = productData?.images?.edges?.[0]?.node?.url;
            if (imageUrl) {
                const imgWrapper = el.querySelector('.bndlr-product-image-url');
                if (imgWrapper) {
                    imgWrapper.innerHTML = `<img src="${imageUrl}" alt="${title}" class="bndlr-product-image" width="300" height="400">`;
                }
            }

            const hiddenTitle = document.createElement('input');
            hiddenTitle.type = 'hidden';
            hiddenTitle.name = `properties[${title}]`;
            hiddenTitle.value = ' ';
            el.appendChild(hiddenTitle);
        })
        .catch(err => console.error('GraphQL metafield fetch error:', err));

        fetchPromises.push(fetchPromise);
    });

    Promise.all(fetchPromises).then(() => {
        console.log('[Bundle Debug] All titles fetched. Waiting for images...');
        waitForImages('.bndlr-product img', () => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    matchTitleHeights();
                    matchHeights();

                    products.forEach(product => {
                        product.classList.remove('loading');
                        product.classList.add('ready');

                        const select = product.querySelector('select.bndlr-select-variant');
                        if (!select || select.options.length < 2) return;

                        const [placeholder, realOption] = select.options;
                        const isDummy = /informational/i.test(placeholder.textContent);
                        const isReal = realOption.textContent.toLowerCase().includes('os');
                        const addButton = product.querySelector('.bndlr-add-to-bundle, .bndlr-add-to-cart, [title="Add to bundle"], [title="Add to cart"]');

                        if (isDummy) {
                            placeholder.textContent = 'Select size';
                            placeholder.disabled = true;
                            if (isReal) {
                                placeholder.style.display = 'none';
                                select.value = realOption.value;
                                select.dispatchEvent(new Event('change', { bubbles: true }));
                                console.log('[Bundle UX] Auto-selected One Size:', realOption.textContent);
                            } else if (addButton) {
                                addButton.setAttribute('disabled', 'disabled');
                                addButton.classList.add('disabled');
                                addButton.style.opacity = '0.5';
                                addButton.style.pointerEvents = 'none';
                            }
                        }

                        const updateGroupAddToCart = () => {
                            const parentBundle = product.closest('.bndlr-container, .bundle-grid, .bndlr-sectioned-available-products');
                            const groupAddToCart = parentBundle?.querySelector('.bndlr-add-to-cart');

                            if (groupAddToCart) {
                                const allSelects = parentBundle.querySelectorAll('select.bndlr-select-variant');
                                const allValid = Array.from(allSelects).every(sel => {
                                    const opt = sel.options[sel.selectedIndex];
                                    return opt && opt.value && !opt.disabled && !/select size/i.test(opt.textContent);
                                });

                                groupAddToCart.disabled = !allValid;
                                groupAddToCart.classList.toggle('disabled', !allValid);
                                groupAddToCart.style.opacity = allValid ? '1' : '0.5';
                                groupAddToCart.style.pointerEvents = allValid ? 'auto' : 'none';
                            }
                        };

                        select.addEventListener('change', () => {
                            const selectedOption = select.options[select.selectedIndex];
                            const isStillDummy = selectedOption.disabled || !selectedOption.value || /select size/i.test(selectedOption.textContent);

                            if (addButton) {
                                if (isStillDummy) {
                                    addButton.setAttribute('disabled', 'disabled');
                                    addButton.classList.add('disabled');
                                    addButton.style.opacity = '0.5';
                                    addButton.style.pointerEvents = 'none';
                                } else {
                                    addButton.removeAttribute('disabled');
                                    addButton.classList.remove('disabled');
                                    addButton.style.opacity = '1';
                                    addButton.style.pointerEvents = 'auto';
                                }
                            }

                            updateGroupAddToCart();
                        });

                        updateGroupAddToCart();
                    });
                });
            });
        });
    });
});
